import {useTranslation} from "react-i18next"
import quickReferenceIcon from "../../assets/icon/quick-reference.svg"
import summarizeIcon from "../../assets/icon/summarize.svg"
import formatListBulletedIcon from "../../assets/icon/format-list-bulleted.svg"
import quickPhrasesIcon from "../../assets/icon/quick-phrases.svg"
import unfoldMoreIcon from "../../assets/icon/unfold-more.svg"
import quickReferenceGreyIcon from "../../assets/icon/quick-reference-grey.svg"
import summarizeGreyIcon from "../../assets/icon/summarize-grey.svg"
import formatListBulletedGreyIcon from "../../assets/icon/format-list-bulleted-grey.svg"
import quickPhrasesGreyIcon from "../../assets/icon/quick-phrases-grey.svg"
import unfoldMoreGreyIcon from "../../assets/icon/unfold-more-grey.svg"

export default function EcpTabChoice({handleSelect, tabs}) {
    const {t} = useTranslation()
    return (
        <>
        <nav class="ecp-tab-choice">
            <p>{t("Customize your publication:")}</p>
            <ul class="tabs">
                <li id="abstract-tab" class="active" tabindex="0" onClick={() => handleSelect("abstract")}>
                    <img src={tabs.includes("abstract") ? quickReferenceIcon : quickReferenceGreyIcon} alt=""/>
                    <p style={{color: tabs.includes("abstract") && "#C30F0E"}}>{t("Abstract")}</p>
                </li>
                <li id="summary-tab" tabindex="1" onClick={() => handleSelect("summary")}>
                    <img src={tabs.includes("summary") ? summarizeIcon : summarizeGreyIcon} alt=""/>
                    <p style={{color: tabs.includes("summary") && "#C30F0E"}}>{t("Summary")}</p>
                </li>
                <li id="keypoints-tab" tabindex="2" onClick={() => handleSelect("keypoints")}>
                    <img src={tabs.includes("keypoints") ? formatListBulletedIcon : formatListBulletedGreyIcon} alt=""/>
                    <p style={{color: tabs.includes("keypoints") && "#C30F0E"}}>{t("Keypoints")}</p>
                </li>
                <li id="verbatims-tab" tabindex="3" onClick={() => handleSelect("verbatims")}>
                    <img src={tabs.includes("verbatims") ? quickPhrasesIcon : quickPhrasesGreyIcon} alt=""/>
                    <p style={{color: tabs.includes("verbatims") && "#C30F0E"}}>{t("Verbatims")}</p>
                </li>
                <li id="glossary-tab" tabindex="4" onClick={() => handleSelect("glossary")}>
                    <img src={tabs.includes("glossary") ? unfoldMoreIcon : unfoldMoreGreyIcon} alt=""/>
                    <p style={{color: tabs.includes("glossary") && "#C30F0E"}}>{t("Glossary")}</p>
                </li>
            </ul>
        </nav>
        </>
    )
}